import { QuestionCreationTaskQuestionDetails } from '@exam-management/question-creation-task-creation';

export default function NewQuestionCreationSingleQuestionDetailsPage() {
  return <QuestionCreationTaskQuestionDetails />;
}
